import React, { useState, useEffect, useRef } from 'react';

export default ({ children, onRefresh }) => {
  const [pullDistance, setPullDistance] = useState(0);
  const [isRefreshing, setIsRefreshing] = useState(false);
  const startY = useRef(0);
  const containerRef = useRef(null);
  const isDragging = useRef(false);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    const onTouchStart = (e) => {
      // Only trigger if at the top of the page
      if (window.scrollY === 0) {
        startY.current = e.touches[0].clientY;
        isDragging.current = true;
      }
    };

    const onTouchMove = (e) => {
      if (!isDragging.current) return;

      const currentY = e.touches[0].clientY;
      const diff = currentY - startY.current;

      if (diff > 0 && window.scrollY === 0) {
        e.preventDefault();
        setPullDistance(Math.min(diff * 0.5, 80)); // Max 80px pull
      }
    };

    const onTouchEnd = () => {
      if (pullDistance > 50) {
        setIsRefreshing(true);
        onRefresh().finally(() => {
          setIsRefreshing(false);
          setPullDistance(0);
        });
      } else {
        setPullDistance(0);
      }
      isDragging.current = false;
    };

    container.addEventListener('touchstart', onTouchStart);
    container.addEventListener('touchmove', onTouchMove);
    container.addEventListener('touchend', onTouchEnd);

    return () => {
      container.removeEventListener('touchstart', onTouchStart);
      container.removeEventListener('touchmove', onTouchMove);
      container.removeEventListener('touchend', onTouchEnd);
    };
  }, [pullDistance, onRefresh]);

  return (
    <div
      ref={containerRef}
      style={{
        minHeight: '100vh',
        overflowY: 'auto',
        WebkitOverflowScrolling: 'touch'
      }}
    >
      <div className="bg-black text-white flex items-center justify-center position-relative"
           style={{
             top: 0,
             left: 0,
             right: 0,
             height: `${pullDistance}px`,
             transition: isRefreshing ? 'height 0.2s' : 'none',
             overflow: 'hidden'
           }}>
        {isRefreshing ? (
          <i className="ph ph-circle-notch spin" />
        ) : pullDistance > 0 && (
          <div>
            ↓ Pull to refresh
          </div>
        )}
      </div>
      {children}
    </div>
  );
};
